export function invalidateOnSuccess(tags: string[]) {
  return (result: unknown) => (result ? tags : [])
}
